import { IGNORE_TAX_EXEMPTION_CODE } from "../constants";
import { getProductAttributeByCode } from "./getProductAttributeByCode";
import { GetProductAttributeBooleanValue } from "./types";

export const getIgnoreTaxExemption: GetProductAttributeBooleanValue = offer => {
  if (!offer) return false;
  const attribute = getProductAttributeByCode(offer, IGNORE_TAX_EXEMPTION_CODE);
  return Boolean(attribute ? attribute.value : false);
};
